// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import * as api from "../shared/api"
import apiPath from "../shared/apiPath"
import * as biz_data_helper from "../shared/biz_data_helper"
import * as SalesOrderController from "./sd/SalesOrderController"

const dictionary = {
  email_form: [
    {
      key: "Notifier_Purch",
      label: "邮件通知（采购）",
      value: ""
    },
    {
      key: "Notifier_Sales",
      label: "邮件通知（销售）",
      value: ""
    },
    {
      key: "Notifier_TPM",
      label: "邮件通知（TPM）",
      value: ""
    },
    {
      key: "Notifier_Route",
      label: "邮件通知（工艺）",
      value: ""
    },
    {
      key: "Notifier_Quote",
      label: "邮件通知（报价）",
      value: ""
    },
    {
      key: "Notifier_Plan",
      label: "邮件通知（主计划）",
      value: ""
    },
    {
      key: "Notifier_Dev",
      label: "邮件通知（研发）",
      value: ""
    },
    {
      key: "Notifier_Proofing_Purch_Distributed",
      label: "邮件通知（打样报价采购预分配后）",
      value: ""
    },
    {
      key: "Notifier_Proofing_TPM_Distributed",
      label: "邮件通知（打样分配完成后）",
      value: ""
    }
  ]
}
function formatDate(_dateTime, format_type = "yyyy-MM-dd") {
  if (_.isDate(_dateTime)) {
    return _date.format(_dateTime, format_type)
  } else if (_.isString(_dateTime)) {
    return _date.format(_date.parseISO(_dateTime), format_type)
  } else {
    return ""
  }
}
const methods = {
  ///发送、取消邮件
  async sendOrCancelNotify(type, _data) {
    console.log(_data)
    let query_settings = []
    if (type == "add") {
      _.each(_data, t => {
        // let _p = {
        //   category: "",
        //   idx: t.idx,
        //   notify_type: t.,
        //   subject: "",
        //   content: ""
        // }
        query_settings.push({
          url: apiPath.email.add_notify,
          parameters: t,
          method: "post"
        })
      })
    } else {
      _.each(_data, t => {
        query_settings.push({
          url: apiPath.email.cancel_notify,
          parameters: t,
          method: "post"
        })
      })
    }
    let data = await api.query_all_async(query_settings)
    if (data) {
      return data[0].result.data.Success
    } else {
      return false
    }
  },
  ///get usernames
  getUserNameFromRole(rolses, t, fromApprover, toApprover, isApproved, isShowApprover) {
    if (isApproved && !isShowApprover) {
      t[toApprover] = ""
    } else if (rolses.length > 0) {
      let _rn_data = []
      _.each(rolses, d => {
        if (!_.isNull(t[fromApprover]) && t[fromApprover]) {
          let _approver = t[fromApprover].split(",")[0]
          if (
            t[fromApprover].split(",").length > 2 &&
            toApprover.indexOf("Up_") > -1
          ) {
            _approver = t[fromApprover].split(",")[2]
          }
          if (d.role_code == _approver) {
            _rn_data.push(d.username)
          } else {
            t[toApprover] = _approver
          }
        }
      })
      if (_rn_data && _rn_data.length > 0) {
        t[toApprover] = _rn_data.join("，")
      }
    }
  },
  ///获取服务器时间
  async getServerDateTime() {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "getServerDateTime",
      {},
      {}
    )
    let result = await code_biz_data
      .execAction({
        params: {},
        fields: ["now", "today"]
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data[0][0]
    } else {
      return null
    }
  },
  ///判断日期是否早于当前服务日期
  async checkIsBeforeCurrentDate(_date) {
    let _date_r = await methods.getServerDateTime()
    if (
      new Date(formatDate(_date_r.today)) >
      new Date(formatDate(_date))
    ) {
      return false
    }
    return true
  },
  ///修改邮件发送状态
  async updateEmailSendState(_type, list) {
    const update_email_state_biz_data = new biz_data_helper.base_entity_helper(
      "update_email_send_state",
      {},
      {}
    )
    let _params = []
    _.each(list, t => {
      _params.push({
        type: _type,
        id: t.id
      })
    })

    let result = await update_email_state_biz_data
      .execAction({
        params: _params
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///判断非自己创建不能修改
  checkIfCanModifyOrder(_this, t) {
    if (
      t.create_by &&
      t.create_by != _this.$store.state.biz_data.userInfo.user_id
    ) {
      _this.msgToasts(_this.$t("notify.not_created_by_yourself"))
      return false
    }
    return true
  },
  ///检查审批权限
  async checkApprovePrivilige(_params, _this) {
    let _check_list = []
    let _approveStatusIdList = []
    let _roles = []

    if (_this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
      _roles = _.map(
        _this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
        "code"
      )
    }
    for (var i in _params.list) {
      let _at = await SalesOrderController.methods.getApproveStatus({
        DocumentType: _params.DocumentType,
        ApproveType: _params.approve_type,
        ItemId: _params.list[i].id
      })
      let _is_ok = true
      for (var j in _at[0]) {
        let at = _at[0][j]
        if (at) {
          if (
            _.includes(_roles, at.Approver) ||
            _this.$global.global_data.local_username == at.Approver ||
            _params.isNotCheckPrivilage
          ) {
            _is_ok = false
          }
          ///要修改的approveStatus的id
          if (_params.action_state) {
            if (
              _.includes(_roles, at.Approver) ||
              _this.$global.global_data.local_username == at.Approver
            ) {
              _approveStatusIdList.push(at)
            }
          } else {
            if (
              _.includes(_roles, at.Approver) ||
              _this.$global.global_data.local_username == at.Approver ||
              _params.list[i].create_by ==
              _this.$store.state.biz_data.userInfo.user_id
            ) {
              if (at.ApproveLevel != 1 && at.Approver == "") {
              } else {
                _approveStatusIdList.push(at)
              }
            }
          }
        }
      }
      if (_is_ok && !_.includes(_check_list, _params.list[i].id)) {
        _check_list.push(_params.list[i].id)
      }
    }
    return {
      notPriviligeIdList: _check_list,
      approveStatusIdList: _approveStatusIdList
    }
  },
  ///单独检查前端权限
  checkPrivilige(_this, p_code, p_text) {
    // console.log(_this.$store.state.biz_data.userInfo)

    let user_roles_list =
      _this.$store.state.biz_data.userInfo.user_roles_privileges.roles
    let _role_index = _.findIndex(user_roles_list, { code: "admin" })
    if (_role_index > -1) {
      return true
    }

    let user_pri_list =
      _this.$store.state.biz_data.userInfo.user_roles_privileges.privileges
    let _index = _.findIndex(user_pri_list, { code: p_code })
    if (_index < 0) {
      let str = ""
      str = '<div class="mt-2">' + p_code + "-" + p_text + "</div>"
      _this.$message({
        dangerouslyUseHTMLString: true,
        message:
          '<div class="ml-auto"><strong style="text-align:center">' +
          _this.$t("notify.not_privileges_content_admin") +
          "</strong></div>" +
          str,
        type: "error",
        showClose: true,
        duration: 0,
        customClass: "zZindex",
        onClose: function () { }
      })
      return false
    }
    return true
  },
  ///记录ax失败参数及原因
  async createAXErorrLog(code, p) {
    let error_actions = []
    let biz_data = new biz_data_helper.base_entity_helper(
      "create_ax_error_log",
      {},
      {}
    )
    error_actions.push(
      biz_data
        .execAction({
          params: {
            code: code,
            message: p.params, //
            error: p.error_msg,
            result: p.result //
          },
          fields: ["r"]
        })
        .action({})
    )
    console.log(error_actions)
    await api.query_batch({
      actions: error_actions
    })
  }
}
async function getEmailDataFromSqlCode(params, sql_code) {
  let biz_data = new biz_data_helper.base_entity_helper(sql_code, {}, {})
  let actions = []
  actions.push(biz_data.execAction({ params: params, fields: ["id"] }).action({}))
  let result = await api.query_batch({ actions: actions })
  if (
    result &&
    result.data &&
    result.data.BatchResult &&
    result.data.BatchResult.Actions &&
    result.data.BatchResult.Actions.length > 0
  ) {
    return result.data.BatchResult.Actions[0].Result.Data
  }
  return null
}
async function handleEmailNotify(params, action_type, _this, allRoleUsers, sql_code, email_users = []) {
  let rt = await getEmailDataFromSqlCode(params, sql_code)
  if (rt && rt.length > 0) {
    if (action_type == "quote_apply") {
      _.forEach(rt, (item) => {
        _.forEach(item, (t) => {
          switch (t.IsHomemade) {
            case 0: t.IsHomemade = '否'; break
            case 1: t.IsHomemade = '是'; break
            case 2: t.IsHomemade = '纯外协'; break
          }
        })
      })
      let e_data = []
      let order_nums = []
      handleData_QuoteApply(rt, e_data, null, order_nums)
      let em = { subject: "", content: "" }
      let template_item = _.find(_this.$store.state.biz_data.templateData.templates, { notify_type: "quote_application" })
      if (template_item) {
        em.subject = `${template_item.subject}，编号：${_.join(order_nums, "，")}`
        var fn = template.compile(template_item.content)
        for (var i in e_data) {
          em.content += `${fn(e_data[i])}<br />`
        }
      }
      return em
    }
    else if (action_type === 'quote_order_confirm') {
      rt = _.groupBy(_.map(rt, (t) => { return t[0] }), "QuotationTaskNum")
    }
    else if (action_type === 'quote_proofing_complated') {
      rt = [_.flattenDeep(rt)]
    }
    await handleEmailData(rt, action_type, _this, allRoleUsers, email_users)
  }
  else return null
}
async function handleEmailData(rt, action_type, _this, allRoleUsers, email_users) {
  let notify_list = []
  for (var i in rt) {
    ///1、邮件通知销售公司
    if (action_type == "quote_order_closed") {
      //因为接口返回数据不统一造成该处要特殊处理
      email_users = []
      email_users.push(i)
    }
    handleSalesCompanyEmail(notify_list, rt[i], action_type, allRoleUsers, _this, email_users)

    ///2、邮件通知(制造商)
    let made_data = []
    // _.each(rt[i], (t) => {
    //   if (t.Manufacturer && t.Manufacturer != "") {
    //     let Manufacturer_split = _.split(t.Manufacturer, ",")
    //     for (var j in Manufacturer_split) {
    //       if (t.dataAreaId != Manufacturer_split[j])
    //         made_data.push({ dataAreaId: Manufacturer_split[j], data: t })
    //     }
    //   }
    // })
    handleMadeCompanyEmail(notify_list, made_data, action_type, allRoleUsers, _this)
  }
  if (notify_list.length > 0) {
    let _rsult = await methods.sendOrCancelNotify("add", notify_list)
    if (!_.isNull(_rsult))
      _this.msgToasts(_this.$t("notify.email_send_success"), "success")
  }
}
///邮件通知销售公司
function handleSalesCompanyEmail(notify_list, email_data, action_type, allRoleUsers, _this, email_users) {
  if (email_data.length > 0) {
    let e_users = []
    let e_data = {}
    let template_code = ""
    //报价申请
    if (action_type == "quote_apply") {
      ///旧邮件处理方式
      // {
      //   let ecodes = [
      //     "Notifier_Sales",
      //     "Notifier_TPM",
      //     "Notifier_Route",
      //     "Notifier_Quote",
      //     "Notifier_Plan",
      //     "Notifier_Dev"  //研发
      //   ]
      //   e_users = handleEusers(email_data[0], allRoleUsers, _this, ecodes)
      //   e_data = { title: "", data: [], items: [] }
      //   handleData_QuoteApply(email_data, e_data)
      //   template_code = "quote_application"
      // }
    }
    //创建询价单
    else if (action_type == "consult_order") {
      e_users = email_users
      e_data = { title: "", data: [], items: [] }
      handleData_ConsultApply(email_data, e_data)
      template_code = "consult_order"
    }
    //BOM及Route完成
    else if (action_type == "bom_and_route") {
      let ecodes = ["Notifier_Quote", "Notifier_Plan"]
      e_users = handleEusers(email_data[0], allRoleUsers, _this, ecodes)
      e_data = { title: "", data: [], items: [] }
      handleData_BomAndRoute(email_data, e_data)
      template_code = "bom_and_route_complated"
    }
    //采购询价预分配完成后邮件通知(大货)
    else if (action_type == "consult_complated") {
      let ecodes = ["Notifier_Quote", "Notifier_Plan"]
      e_users = handleEusers(email_data[0], allRoleUsers, _this, ecodes)
      e_data = {}
      handleData_ConsultComplate(email_data, e_data)
      template_code = "consult_complated"
    }
    //主计划分配完成
    else if (action_type == "quote_distribution_complated") {
      if (email_data[0].fcGetSQODApprover && email_data[0].fcGetSQODApprover != "") {
        let approver = email_data[0].fcGetSQODApprover.split(",")[0]
        ///判断是否角色
        if (_.findIndex(allRoleUsers, { role_code: approver }) > -1) {
          let role_users = _.filter(allRoleUsers, { role_code: approver })
          if (role_users.length > 0) {
            const role_usernames = _.map(role_users, (m) => { return m.username })
            e_users = _.union(e_users, role_usernames)
          }
        }
        else if (_.findIndex(e_users, approver) < 0) {
          e_users.push(approver)
        }
      }
      e_data = { title: "", data: [], items: [] }
      handleData_DistributionComplate(email_data, e_data)
      template_code = "quote_distribution_complated"
    }
    //主计划的审批完成
    else if (action_type == "quote_distribution_approved") {
      let ecodes = ["Notifier_Quote", "Notifier_Plan"]
      e_users = handleEusers(email_data[0], allRoleUsers, _this, ecodes)
      e_data = {
        title: email_data[0].QuotationTaskNum,
        url: window.location.protocol + "//" + window.location.host + "/sq/QuotationOrderConfirm",
        url_name: window.location.host + "/sq/QuotationOrderConfirm"
      }
      template_code = "quote_distribution_approved"
    }
    //加权成本确认
    else if (action_type == "quote_order_confirm") {
      e_users = email_users
      e_data = { title: "", data: [], items: [] }
      handleData_QuoteOrderConfirm(email_data, e_data)
      template_code = "quote_weighted_cost_confirmed"
    }
    //报价单审核
    else if (action_type == "quote_order_approved") {
      e_users.push(email_data[0].create_by_username)
      e_users = _.uniq(e_users)
      e_data = {
        title: `报价申请编号为${email_data[0].QuotationTaskNum} 已审批通过，请通过以下链接登录到报价调整窗体进行查询`,
        url: `${window.location.protocol}//${window.location.host}/sq/QuotationTask?tab=2`,
        url_name: `${window.location.host}/sq/QuotationTask`
      }
      if (_this.email_action_type == "refused") {
        e_data.title = `报价申请编号为${email_data[0].QuotationTaskNum}已退回，请通过以下链接登录到报价调整窗体进行处理`
      }
      handleData_QuoteOrderApproved(email_data, e_data, _this)
      template_code = "quote_complated"
    }
    //关闭报价申请
    else if (action_type == "quote_order_closed") {
      e_users = _.union(e_users, email_users)
      e_users = _.uniq(e_users)
      e_data = {
        url: `${window.location.protocol}//${window.location.host}/sq/QuotationTask?tab=3`,
        url_name: `${window.location.host}/sq/QuotationTask`,
        items: email_data
      }
      template_code = "quote_closed"
    }
    //采购询价预分配完成后邮件通知(打样，注：邮件模板和大货相同)
    else if (action_type == "consult_complated_proofing") {
      let ecodes = ["Notifier_Proofing_Purch_Distributed"]
      e_users = handleEusers(email_data[0], allRoleUsers, _this, ecodes)
      e_data = {}
      handleData_ConsultComplate(email_data, e_data)
      template_code = "consult_complated"
    }
    //打样报价分配完成
    else if (action_type == "quote_proofing_complated") {
      let ecodes = ["Notifier_Proofing_TPM_Distributed"]
      e_users = handleEusers(email_data[0], allRoleUsers, _this, ecodes)
      _.forEach(email_data, (t) => {
        switch (t.IsHomemade) {
          case 0: t.IsHomemade = '否'; break
          case 1: t.IsHomemade = '是'; break
          case 2: t.IsHomemade = '纯外协'; break
        }
      })
      e_data = {
        url: `${window.location.protocol}//${window.location.host}/sq/QuotationOrderProofing`,
        url_name: `${window.location.host}/sq/QuotationOrderProofing`,
        items: email_data
      }
      template_code = "quote_proofing_complated"
    }
    notify_list.push(excuteSendAction(e_users, e_data, _this, template_code))
  }
}
///邮件通知(制造商)
function handleMadeCompanyEmail(notify_list, made_data, action_type, allRoleUsers, _this) {

  if (made_data.length > 0 && (action_type == "quote_apply" || action_type == "bom_and_route")) {
    let ecodes = ["Notifier_Route"]
    let group_made_data = _.groupBy(made_data, "dataAreaId")

    ///根据每个制造商发送邮件
    for (var k in group_made_data) {
      let notify_item = { e_users: [], e_data: { title: "", data: [], items: [] }, template_code: "" }
      notify_item.e_users = handleEusers({
        dataAreaId: k,
        EmailNotifierJson_Cust: group_made_data[k][0].data.EmailNotifierJson_Cust
      }, allRoleUsers, _this, ecodes)
      //报价申请
      if (action_type == "quote_apply") {
        notify_item.template_code = "quote_application"
        handleData_QuoteApply(_.map(group_made_data[k], (t) => { return t.data }), notify_item.e_data, k)
      }
      //BOM及Route完成
      else if (action_type == "bom_and_route") {
        notify_item.template_code = "bom_and_route_complated"
        handleData_BomAndRoute(_.map(group_made_data[k], (t) => { return t.data }), notify_item.e_data, k)
      }
      notify_list.push(excuteSendAction(notify_item.e_users, notify_item.e_data, _this, notify_item.template_code))
    }
  }
}
///发送邮件
function excuteSendAction(e_users, e_data, _this, template_code) {
  let templates = _this.$store.state.biz_data.templateData.templates
  let send_to = {}
  for (var i in e_users) {
    send_to[e_users[i]] = ""
  }
  let em = {
    category: template_code,
    idx: "",
    itemId: 0,
    notify_type: template_code,
    subject: "",
    content: "",
    SendTo: send_to
  }

  if (templates) {
    let m = _.find(templates, { notify_type: template_code })
    if (m) {
      var fn = template.compile(m.content)
      em.content = fn(e_data)
      em.subject = m.subject
    }
  }
  if (_this.email_action_type == "refused" && template_code == "quote_complated")
    em.subject = "CPSP报价已退回"
  return em
}
function handleEusers(email_item, allRoleUsers, _this, email_codes) {
  let et = []
  let e_users = []
  let item = {
    dataAreaId: email_item.dataAreaId,
    EmailNotifierJson_Cust: email_item.EmailNotifierJson_Cust
  }
  ///客户的相关邮件设置
  if (item.EmailNotifierJson_Cust && item.EmailNotifierJson_Cust != "") {
    let et1 = JSON.parse(item.EmailNotifierJson_Cust)
    et = et1
  }
  console.log(et)
  ///销售公司、制造商相关邮件设置
  let EmailNotifierJson_Sales = _.find(
    _this.$store.state.biz_data.baseData.CompanyInfo,
    { DataArea: item.dataAreaId }
  )
  if (
    EmailNotifierJson_Sales &&
    EmailNotifierJson_Sales.EmailNotifierJson &&
    EmailNotifierJson_Sales.EmailNotifierJson != ""
  ) {
    let et1 = JSON.parse(EmailNotifierJson_Sales.EmailNotifierJson)
    _.each(et1, t => {
      if (_.findIndex(et, mt => t.key == mt.key && mt.value && mt.value.length > 0) < 0)
        et[t.key] = t
    })
  }
  let eut = getEmailUser(et, email_codes, allRoleUsers)
  e_users = _.union(e_users, eut)
  return e_users
}
function getEmailUser(et, email_codes, allRoleUsers) {
  let e_users = []
  for (var k in et) {
    let t = et[k]
    if (_.includes(email_codes, t.key) && t.value && t.value.length > 0) {
      for (var i in t.value) {
        let isRole = _.findIndex(allRoleUsers, { role_code: t.value[i] }) > -1
        if (isRole) {
          let role_users = _.filter(allRoleUsers, { role_code: t.value[i] })
          if (role_users.length > 0)
            e_users = _.union(
              e_users,
              _.map(role_users, m => {
                return m.username
              })
            )
        } else if (!_.includes(e_users, t.value[i])) {
          e_users.push(t.value[i])
        }
      }
    }
  }
  return e_users
}
///处理报价申请邮件数据
function handleData_QuoteApply(rt, e_data, made_company, order_nums) {
  _.each(rt, (k) => {
    if (k && k.length > 0) {
      let e_data_item = { title: "", data: [], items: [] }
      e_data_item.title = "CPSP报价申请：" + k[0].QuotationTaskNum + "已创建"
      if (!_.includes(order_nums, k[0].QuotationTaskNum)) order_nums.push(k[0].QuotationTaskNum)
      let _t = _.clone(k[0])
      let m = {
        id: _t.id,
        QuotationTaskNum: _t.QuotationTaskNum,
        CustAccount: _t.CustAccount,
        CustName: _t.CustName,
        dataAreaId: _t.dataAreaId,
        CompanyName: _t.CompanyName,
        ComplateDate: !_t.ComplateDate ? "" : formatDate(_t.ComplateDate),
        Description: _t.Description,
        create_by_username: _t.create_by_username,
        create_at: !_t.create_at ? "" : formatDate(_t.create_at),
        fcCheckSQOApproved: _t.fcCheckSQOApproved,
        SQOApprover: _t.SQOApprover
      }
      _.each(k, t => {
        t.DemandDate = !t.DemandDate ? "" : formatDate(_t.DemandDate)
        if (made_company) t.Manufacturer = made_company
        e_data_item.items.push(t)
      })
      e_data_item.data.push(m)
      e_data.push(e_data_item)
    }
  })
}
///处理创建询价单邮件数据
function handleData_ConsultApply(rt, e_data) {
  //数据
  let m = {}
  _.each(rt, t => {
    e_data.title = "CPSP报价申请：" + t.QuotationTaskNum + " 询价申请" + t.ConsultQuoteApplyNum + "已创建"
    m = {
      id: t.id,
      ConsultQuoteApplyNum: t.ConsultQuoteApplyNum,
      Description: t.Description,
      create_by_username: t.create_by_username,
      create_at: formatDate(t.create_at, "yyyy-MM-dd"),
      is_valid: t.is_valid ? "是" : "否"
    }
    e_data.items.push(t)
  })
  if (e_data.data.length == 0) e_data.data.push(m)
}
///处理BOM及Route完成邮件数据
function handleData_BomAndRoute(rt, e_data, made_company) {
  let item = rt[0]
  e_data.title =
    "CPSP报价申请：" + item.QuotationTaskNum + " BOM及工艺已经确定"
  let BomData = JSON.parse(item.BomID)
  let RouteData = JSON.parse(item.RouteID)
  ///Bom
  _.each(BomData, t => {
    let m = {
      LineNum: item.LineNum,
      ItemId: item.ItemId,
      NameAlias: item.NameAlias,
      Manufacturer: item.dataAreaId,
      BomConfirmState: item.BomConfirmState ? "是" : "否",
      AccountNum: t.AccountNum,
      AccountName: t.AccountName,
      BomId: t.BomID,
      BomName: t.BomVersionName
    }
    if (made_company) m.Manufacturer = made_company
    e_data.items.push(m)
  })

  ///工艺
  e_data.items1 = []
  _.each(RouteData, t => {
    let m = {
      LineNum: item.LineNum,
      ItemId: item.ItemId,
      NameAlias: item.NameAlias,
      Manufacturer: item.dataAreaId,
      RouteConfirmState: item.RouteConfirmState ? "是" : "否",
      AccountNum: t.AccountNum,
      AccountName: t.AccountName,
      RouteId: t.RouteID,
      RouteName: t.RouteVersionName
    }
    if (made_company) m.Manufacturer = made_company
    e_data.items1.push(m)
  })
}
///处理供应商报价启用邮件数据
function handleData_ConsultComplate(rt, e_data) {
  let _lineNum = 1
  let qt_group_dt = _.groupBy(rt, 'QuotationTaskNum')
  let email_list = []
  for (var key in qt_group_dt) {
    let m = { title: '', data: [] }
    m.title = "CPSP报价申请：" + key + " 采购询价已完成"
    let item_group_dt = _.groupBy(qt_group_dt[key], "LineNum")
    for (var j in item_group_dt) {
      let data_items = { main: {}, items: [] }
      data_items.main = item_group_dt[j][0]
      for (var k in item_group_dt[j]) {
        let t = item_group_dt[j][k]
        if (t.DistributionRatio && t.DistributionRatio != "") {
          let dm = _.find(JSON.parse(t.DistributionRatio), { ItemId: t.ItemId })
          if (dm) {
            let _totalCost = t.ToQty ? t.ToQty : t.FromQty
            data_items.items.push({
              LineNum: _lineNum++,
              AccountNum: t.AccountNum,
              AccountName: t.AccountName,
              Price_WOTax: t.Price_WOTax,
              TotalCost: _.round(((_totalCost * _.toNumber(dm.DistributionRatio)) / 100) * t.Price_WOTax, 6),
              DistributionRatio: dm.DistributionRatio,
              FromQty: t.FromQty,
              ToQty: t.ToQty,
              Qty: _.round((_totalCost * _.toNumber(dm.DistributionRatio)) / 100, 6)
            })
          }
        }
      }
      if (data_items.items.length > 0)
        m.data.push(data_items)
    }
    email_list.push(m)
  }
  e_data.list = email_list
}
///处理主计划的审批完成邮件数据
function handleData_DistributionComplate(rt, e_data) {
  e_data.data = []
  _.each(rt, t => {
    e_data.title = "CPSP主计划分配已完成"
    e_data.url = window.location.protocol + "//" + window.location.host + "/sq/QTHDistribution?tab=2"
    e_data.url_name = window.location.host + "/sq/QTHDistribution"
    e_data.items.push(t)
  })
}
///处理加权成本确认邮件数据
function handleData_QuoteOrderConfirm(rt, e_data) {
  e_data.data = []
  _.each(rt, t => {
    e_data.title = "CPSP加权成本已确认"
    e_data.url = window.location.protocol + "//" + window.location.host + "/sq/QuotationOrder"
    e_data.url_name = window.location.host + "/sq/QuotationOrder"
    e_data.items.push(t)
  })
}
///处理报价单审核邮件数据
function handleData_QuoteOrderApproved(rt, e_data, _this) {
  //数据
  let m = {}
  _.each(rt, t => {
    // e_data.title = "CPSP报价申请：" + t.QuotationTaskNum + "已创建";
    t.create_at = formatDate(t.create_at, "yyyy-MM-dd")
    let dm = _.find(_this.$store.state.biz_data.baseData.CompanyInfo, {
      DataArea: t.dataAreaId
    })
    if (dm) t.CompanyName = dm.CompanyName
    m = {
      id: t.QuotationTaskId,
      QuotationTaskNum: t.QuotationTaskNum,
      CustAccount: t.CustAccount,
      CustName: t.CustName,
      dataAreaId: t.dataAreaId,
      CompanyName: t.CompanyName,
      ComplateDate: formatDate(t.ComplateDate, "yyyy-MM-dd"),
      Description: t.Description,
      create_by_username: t.create_by_username,
      create_at: t.create_at
    }
    t.LineNum = t.QuotationTaskLineNum
    e_data.items.push(t)
  })
  if (e_data.data.length == 0) e_data.data.push(m)
}
export { dictionary, excuteSendAction, formatDate, handleEmailData, handleEmailNotify, methods }

